<template>
  <section class="NewsWeb__confirmation0013">
    <el-row :gutter="0" class="NewsWeb__confirmationHead">
      <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="NewsWeb__confirmationSpan">お試し検索結果</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="NewsWeb__confirmationBody">
      <p  class="Trial__Search__Results">お試し検索結果 ({{this.TotalCount}}件)</p>
     <div class="templateParent1" v-if="news_article_flag && user_group_news_article_flag">
      <template>
        <!-- <el-tabs type="card" class="newsWeb__tab">
          <el-tab-pane class="newsWeb__tab__pane" v-loading="loading" > -->
            <el-collapse v-model="collapseNews" accordion>
              <el-collapse-item :title="`${ this.getNewsCount }`" name="1" >
                <div  v-if="getnewsWeb__tabpane__article.length>0">
              <div v-for="articleInfo in getnewsWeb__tabpane__article" v-bind:key="articleInfo.article_id" class="newsWeb__set">

                <div class="newsWeb__tabpane__article" >
                    <el-row class="newsWeb__tabpane__row">
                        <div class="newsWeb__tabpane__article__id" v-if="articleInfo.article_no !=' '">
                            {{articleInfo.article_no}}
                        </div>
                        <div class="newsWeb__tabpane__article__headline" v-if="articleInfo.title !=' '">
                            <p>{{articleInfo.title}}</p>
                        </div>
                    </el-row>
                    <el-row class="newsWeb__tabpane__row">
                        <!-- <div class="newsWeb__tabpane__article__company">
                          <img :src=articleInfo.articleImage alt="logo" />
                        </div> -->
                        <div v-if="articleInfo.data_section == 1">
                          <img src="../../assets/sp_image/header_logoArticle.png" alt="CompanyLogo" width="60" />
                        </div>
                        <div v-else-if="articleInfo.data_section == 2">
                          <img src="../../assets/image/Nikkie-logo-web.svg" alt="NikkieLogo" width="60" />
                        </div>
                        <div class="newsWeb__tabpane__article__info">
                          <span v-if="articleInfo.media_name !=''">●{{articleInfo.media_name}}</span>
                          <span v-if="articleInfo.issue_date !=''">●{{articleInfo.issue_date}}</span>
                          <span v-if="articleInfo.issue_type !=''">●{{ articleInfo.issue_type }}</span>
                          <span v-if="articleInfo.search_word !=''">●{{articleInfo.search_word}}</span>
                        </div>
                    </el-row>
                </div>
                <div  v-if="articleInfo.comment !=''" class="newsWeb__tabpane__comment" >
                    <el-row class="comment__row">
                        <div class="comment__icon"></div>
                        <div>
                          <span class="comment__span" v-html="articleInfo.comment"></span>
                        </div>
                    </el-row>
                </div>       
              </div>
                </div>
              <div v-else>
                  <p class="noresult">ヒット結果は0件です</p>
                </div>
              </el-collapse-item>
            </el-collapse>
          <!-- </el-tab-pane>
        </el-tabs> -->
      </template>
     </div>
      <div class="templateParent2" v-if="getMagazine_Article_Flag && getUserGroup_Magazine_Article_Flag" style="margin-bottom: 10px">
        <template>
          <!-- <el-tabs type="card" class="newsWeb__tab">
            <el-tab-pane :label="this.getWebCount" class="newsWeb__tab__pane" v-loading="loading" > -->
          <el-collapse v-model="collapseNews" accordion>
            <el-collapse-item :title="`${this.getMagazineCount }`" name="5" >
              <div v-if="getMagazineArticles.length>0">
                <div v-for="articleInfo in getMagazineArticles" v-bind:key="articleInfo.article_id" class="newsWeb__set">

                  <div class="newsWeb__tabpane__article" >
                    <el-row class="newsWeb__tabpane__row">
                      <div class="newsWeb__tabpane__article__id" v-if="articleInfo.article_no !=' '">
                        {{articleInfo.article_no}}
                      </div>
                      <div class="newsWeb__tabpane__article__headline" v-if="articleInfo.title !=' '">
                        <p v-if="articleInfo.sales_datetime_flag">{{articleInfo.title}}</p>
                        <p v-else style="color:black">{{articleInfo.title}}</p>
                      </div>
                    </el-row>
                    <el-row class="newsWeb__tabpane__row">
                      <div class="newsWeb__tabpane__article__infoweb">
                        <span v-if="articleInfo.magazine_name !=''">● {{articleInfo.magazine_name}}</span>
                        <span v-if="articleInfo.cover_date !=''">● {{articleInfo.cover_date}}</span>
                        <span v-if="articleInfo.page !=''">● {{articleInfo.page}}</span>
                        <span v-if="articleInfo.category !=''">● {{articleInfo.category}}</span>
                        <span v-if="!articleInfo.title.startsWith('こちらの雑誌はデータ更新があったため削除されました。')">● {{articleInfo.sales_date}}</span>
                        <span v-else>● 提供期間：-</span>
                      </div>
                    </el-row>
                  </div>
                  <div v-if="articleInfo.comment !=''" class="newsWeb__tabpane__comment">
                    <el-row class="comment__row">
                      <div class="comment__icon"></div>
                      <div>
                        <span class="comment__span" v-html="articleInfo.comment"></span>
                      </div>
                    </el-row>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="noresult">ヒット結果は0件です</p>
              </div>
            </el-collapse-item>
          </el-collapse>
          <!-- </el-tab-pane>
        </el-tabs> -->
        </template>
      </div>
     <div class="templateParent2" v-if="web_news_article_flag && user_group_web_news_article_flag">
      <template>
        <!-- <el-tabs type="card" class="newsWeb__tab">
          <el-tab-pane :label="this.getWebCount" class="newsWeb__tab__pane" v-loading="loading" > -->
            <el-collapse v-model="collapseNews" accordion>
              <el-collapse-item :title="`${this.getWebCount }`" name="2" >
            <div v-if="getWebArticles.length>0">
          <div v-for="articleInfo in getWebArticles" v-bind:key="articleInfo.article_id" class="newsWeb__set">

            <div class="newsWeb__tabpane__article" >
                <el-row class="newsWeb__tabpane__row">
                    <div class="newsWeb__tabpane__article__id" v-if="articleInfo.article_no !=' '">
                        {{articleInfo.article_no}}
                    </div>
                    <div class="newsWeb__tabpane__article__headline" v-if="articleInfo.title !=' '">
                        <p>{{articleInfo.title}}</p>
                    </div>
                </el-row>
                <el-row class="newsWeb__tabpane__row">
                    <div class="newsWeb__tabpane__article__infoweb">
                      <span v-if="articleInfo.media_name !=''">● {{articleInfo.media_name}}</span>
                      <span v-if="articleInfo.reporting_date !=''">● {{articleInfo.reporting_date}}</span>
                      <span v-if="articleInfo.category !=''">● {{articleInfo.category}}</span>
                      <span v-if="articleInfo.media_type !=''">● {{articleInfo.media_type}}</span>
                    </div>
                </el-row>
            </div>
            <div v-if="articleInfo.comment !=''" class="newsWeb__tabpane__comment">
                <el-row class="comment__row">
                    <div class="comment__icon"></div>
                    <div>
                      <span class="comment__span" v-html="articleInfo.comment"></span>
                    </div>
                </el-row>
            </div>       
          </div>
            </div>
            <div v-else>
              <p class="noresult">ヒット結果は0件です</p>
            </div>
            </el-collapse-item>
            </el-collapse>
          <!-- </el-tab-pane>
        </el-tabs> -->
      </template>
     </div>


    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
//import Vue from 'vue';
//import Common from '../../common/CommonFunc.js'
export default {
  name: "NewsWeb__confirmation0013",
  props: [],
  data() {
    return {
      newsCount: '',
      webCount: '',
      TotalCount: 0,
      activeName: 'first',
      collapseNews: '1',
      loading:false,
       isActive: false,
      isMedActive: false,
      isBigActive: false,
      news_article_flag: false,
      web_news_article_flag: false,
      user_group_news_article_flag: false,
      user_group_web_news_article_flag: false
    };
  },
  methods: {}, 
  computed: {
    ...mapGetters("sp_Situation0013", ["getTotalNewsCount","getTotalWebCount","getTotalMagazineCount","getnewsWeb__tabpane__article","getWebArticles","getMagazineArticles","getNewsCount","getWebCount","getMagazineCount","getTotalCount"]),
    ...mapGetters("situation0001", [
      "getNews_Article_Flag",
      "getDefault_Font_Size",
      "getWeb_News_Article_Flag",
      "getMagazine_Article_Flag",
      "getUserGroup_News_Article_Flag",
      "getUserGroup_Web_News_Article_Flag",
      "getUserGroup_Magazine_Article_Flag"

    ])
  },
  mounted()
   {
      var font_size_flag = this.getDefault_Font_Size
    console.log(font_size_flag)
      if(font_size_flag == 0)
    {
      this.isActive = true
      this.isMedActive = false
      this.isBigActive = false
    }
    else if(font_size_flag == 1)
    {
      this.isActive = false
      this.isMedActive = true
      this.isBigActive = false
    }
    else
    {
      this.isActive = false
      this.isMedActive = false
      this.isBigActive = true
    }
    //get the news_article_flag from the session
    this.news_article_flag = this.getNews_Article_Flag
    console.log(this.news_article_flag);
    //get the web_news_article_flag from the session
    this.web_news_article_flag = this.getWeb_News_Article_Flag
   console.log(this.web_news_article_flag);
    //get the user_group_news_article_flag from the session
    this.user_group_news_article_flag = this.getUserGroup_News_Article_Flag
    //console.log(this.user_group_news_article_flag);
    //get the user_group_web_news_article_flag from the session
    this.user_group_web_news_article_flag = this.getUserGroup_Web_News_Article_Flag
   //console.log(this.user_group_web_news_article_flag);

if(this.news_article_flag && this.web_news_article_flag && this.user_group_news_article_flag && this.user_group_web_news_article_flag)
    {
      this.activeName = "first"
    }
    else if(this.news_article_flag && this.user_group_news_article_flag)
    {
      this.activeName = "second"
    }
    else if(this.web_news_article_flag && this.user_group_web_news_article_flag)
    {
      this.activeName = "third"
    }
    else
    {
      //no action needed
    }
      var credentials = JSON.parse(this.$session.get('data'));
      this.loading=true;
     this.$store.dispatch('sp_Communication0013/getNewsArticles',credentials).then(()=>{
       this.TotalCount+=this.news_article_flag && this.user_group_news_article_flag?this.getTotalNewsCount:0
       this.TotalCount+=this.web_news_article_flag && this.user_group_web_news_article_flag?this.getTotalWebCount:0
       this.TotalCount+=this.getMagazine_Article_Flag && this.getUserGroup_Magazine_Article_Flag?this.getTotalMagazineCount:0
			this.loading=false;
		}).catch(() => {
            this.loading = false;
          })
     this.newsCount = this.getNewsCount;
     console.log(this.newsCount)
     this.webCount = "WEB 1/" + this.getWebCount + "件";
     console.log(this.getNewsCount);
   },
  // created() {
  //   var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  //   if (isMobile) {
  //       this.$router.push('0013');
  //   }
  //   else{
  //       this.$router.push('/0013');
  //   }
  // },
    beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0013","/0013"); // MobileScreen Path, WebScreen Path
 }
};
</script>

<style scoped>
@import "0013.css";
@import  "../../assets/css/customStyle.css";
</style>